import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const DocumentCompletion = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { finalResponses } = location.state; 
  const handleClose = () => {
    navigate('/dashboard');
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-semibold text-teal-600 mb-4">Document Compilation Completed</h1>

      <div className="flex items-center space-x-2 mb-4">
        <span className="text-green-500 text-3xl">✔️</span>
        <h2 className="text-xl font-semibold">All documents have been reviewed and compiled successfully.</h2>
      </div>

      <div className="mt-4">
        <h3 className="text-lg font-medium">Submission Data (JSON):</h3>
        <pre className="bg-gray-100 p-4 rounded-lg whitespace-pre-wrap overflow-x-auto">
          {JSON.stringify(finalResponses, null, 2)}
        </pre>
      </div>

      <div className="mt-6 text-center">
        <button
          onClick={handleClose}
          className="px-8 py-4 bg-teal-600 text-white text-lg rounded-lg hover:bg-teal-700 transition duration-300"
        >
          Close and Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default DocumentCompletion;
